// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';
import { type Currency, type CurrencyWireFormat, NewCurrency } from '../Currency/Currency';
import {
  NewProductMarginOverview,
  type ProductMarginOverview,
  type ProductMarginOverviewWireFormat,
} from '../ProductMarginOverview/ProductMarginOverview';

export class PlantMarginOverview {
  readonly id: string;
  readonly name: string;
  readonly targetMarginPercentageOverride: string | null;
  readonly minimumMarginPercentageOverride: string | null;
  readonly targetMarginFlatAmountOverride: Currency | null;
  readonly minimumMarginFlatAmountOverride: Currency | null;
  readonly products: ProductMarginOverview[];

  constructor(data: { [key: string]: any } = {}) {
    this.id = data.id === undefined ? '' : data.id;
    this.name = data.name === undefined ? '' : data.name;
    this.targetMarginPercentageOverride =
      data.targetMarginPercentageOverride === undefined
        ? null
        : data.targetMarginPercentageOverride;
    this.minimumMarginPercentageOverride =
      data.minimumMarginPercentageOverride === undefined
        ? null
        : data.minimumMarginPercentageOverride;
    this.targetMarginFlatAmountOverride =
      (data.targetMarginFlatAmountOverride ?? null) === null
        ? null
        : NewCurrency(data.targetMarginFlatAmountOverride);
    this.minimumMarginFlatAmountOverride =
      (data.minimumMarginFlatAmountOverride ?? null) === null
        ? null
        : NewCurrency(data.minimumMarginFlatAmountOverride);
    this.products = (data.products ?? []).map((products: any) =>
      NewProductMarginOverview(products),
    );
  }

  static zero(): PlantMarginOverview {
    const zeroValues: ExcludeMethodsDeep<PlantMarginOverview> = {
      id: '',
      name: '',
      targetMarginPercentageOverride: null,
      minimumMarginPercentageOverride: null,
      targetMarginFlatAmountOverride: null,
      minimumMarginFlatAmountOverride: null,
      products: [],
    };
    return new PlantMarginOverview(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************
  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type PlantMarginOverviewWireFormat = {
  id: string;
  name: string;
  targetMarginPercentageOverride: string | null;
  minimumMarginPercentageOverride: string | null;
  targetMarginFlatAmountOverride: CurrencyWireFormat | null;
  minimumMarginFlatAmountOverride: CurrencyWireFormat | null;
  products: ProductMarginOverviewWireFormat[];
};

type NewPlantMarginOverviewProps = PartialDeep<PlantMarginOverview, { recurseIntoArrays: true }>;
export const NewPlantMarginOverview: (props: NewPlantMarginOverviewProps) => PlantMarginOverview = (
  props,
) => new PlantMarginOverview(props);

type NewPlantMarginOverviewFromWireFormatProps = PartialDeep<
  PlantMarginOverviewWireFormat,
  { recurseIntoArrays: true }
>;
export const NewPlantMarginOverviewFromWireFormat: (
  props: NewPlantMarginOverviewFromWireFormatProps,
) => PlantMarginOverview = (props) => new PlantMarginOverview(props);
